import * as React from 'react';

import { PercentageDiscountIcon, theme } from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetail/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useVoucherDiscountContext } from '../context';

import { ProductDiscount } from './ProductDiscount';
import {
  VoucherDiscountInfoWrapper,
  VoucherDiscountIconWrapper,
} from './styled';

export interface IVoucherDiscountInfoProps {
  highlightedDiscountAmount: string | JSX.Element;
  instructionsText: JSX.Element;
  infoTooltipText: JSX.Element;
  discountCode: string;
  percentage: number;
  showPercentageIcon: boolean;
  highlightedDiscountAmountColor?: string;
}

export const VoucherDiscountInfo: React.FC<IVoucherDiscountInfoProps> = ({
  showPercentageIcon,
  percentage,
  ...props
}) => {
  const newDesign = useNewPdDesignEnabled();
  const { voucherNewDesign } = useFeatureFlags();
  const { isUnderSelectBox, isArrowHidden } = useVoucherDiscountContext();
  const { currentVariant } = useProductDetailContext();

  const hasBlackFridayDiscount =
    currentVariant.attributes?.VoucherDiscount?.tags?.includes(
      'summerblackfriday'
    ) ||
    currentVariant.attributes?.VoucherDiscount?.tags?.includes('blackfriday');

  const bgColor = hasBlackFridayDiscount
    ? theme.color.background.inverse
    : theme.color.background.highlight;

  return (
    <VoucherDiscountInfoWrapper
      newDesign={newDesign}
      showArrow={voucherNewDesign && !isArrowHidden}
      newVoucherDesign={voucherNewDesign}
      isUnderSelectBox={isUnderSelectBox}
    >
      <ProductDiscount {...props} />

      {showPercentageIcon && (
        <VoucherDiscountIconWrapper
          data-testid="voucher-discount-icon"
          voucherNewDesign={voucherNewDesign}
        >
          <PercentageDiscountIcon percentage={percentage} bgColor={bgColor} />
        </VoucherDiscountIconWrapper>
      )}
    </VoucherDiscountInfoWrapper>
  );
};
